import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import { DataWrapperClass } from '../../../../screens/settings/ContactListPrivate/styles'
import { CustomTabs } from '../styles/main';
import Select from 'react-select-plus';
import { modalType } from '../../../../../helpers/dotenv';
import { ButtonCommonTheme, ModalFooter, FormWrapper, FormColumn, FormGroup, ControlLabel, FormControl } from 'modules/theme';
import styled from 'styled-components';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { convertToRaw, EditorState } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';

const TabItemsStyle = styled.div`
    padding: 20px;
    height: calc(100vh - 195px);
    overflow: auto;

//   .Select-control {
//     border: 1px solid #ccc;
//     border-radius: 10px;
//   }
`;
export class ContactInfoNoteTheme extends Component {

    constructor(props) {
        super(props);
        this.assignedToOptions = ['CALLBACK', 'NONE', 'FLOW', 'MISSED_CALL'];
        this.state = {
            sms: '',
            to: '',
            sub: '',
            // editorState: EditorState.createEmpty(),
        }
    }

    // onEditorStateChange(editorState) {
    //     this.setState({
    //         editorState,
    //     });
    // }


    generateParamsFromArray(tData) {
        return tData.map(tD => ({
            value: tD,
            label: tD
        }));
    }

    renderFormGroup(label, props) {
        return (
            <FormGroup>
                <ControlLabel required={props.required}>{label}</ControlLabel>
                <FormControl {...props} />
            </FormGroup>
        );
    }

    render() {
        // const { editorState } = this.state;
        return (
            <DataWrapperClass style={{ background: '#fff', borderRadius: '0px 10px 10px 0px', marginBottom: '25px', display: "none" }}>
                <CustomTabs>
                    <Tabs
                        defaultActiveKey="sms"
                        id="uncontrolled-tab-example"
                        className="customTabs"
                    >
                        <Tab eventKey="sms" title="SMS">
                            <TabItemsStyle>
                                <form>
                                    <FormGroup>
                                        {/* <ControlLabel>Select</ControlLabel> */}
                                        {/* <Select
                                            placeholder="Select"
                                            required={false}
                                            onChange={item => {
                                                if (item) {
                                                    this.setState({ sms: item.value || '' });
                                                } else {
                                                    this.setState({ sms: '' });
                                                }
                                            }}
                                            value={this.state.sms}
                                            options={this.generateParamsFromArray(this.assignedToOptions)}
                                        /> */}
                                        <Editor
                                            // editorState={editorState}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            onEditorStateChange={this.onEditorStateChange}
                                        />
                                        {/* <textarea
                                            disabled
                                            value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                                        /> */}
                                    </FormGroup>
                                    <ModalFooter style={{ position: 'relative', padding: '0px' }}>
                                        <ButtonCommonTheme
                                            type='blueModalBtn'
                                            btnType="submit"
                                            btnStyle="default"
                                            size="xl"
                                            style={{ float: 'right' }}
                                        >
                                            Save
                                        </ButtonCommonTheme>
                                    </ModalFooter>
                                </form>
                            </TabItemsStyle>
                        </Tab>
                        <Tab eventKey="email" title="EMAIL">
                            <TabItemsStyle>
                                <form>
                                    <FormWrapper>
                                        <FormColumn>
                                            {this.renderFormGroup('To', {
                                                defaultValue: '',
                                                // disabled: true,
                                                type: 'text',
                                                id: 'to',
                                                required: false,
                                                value: this.state.to,
                                                onChange: e => {
                                                    this.setState({ to: e.target.value });
                                                }
                                            })}
                                        </FormColumn>
                                    </FormWrapper>
                                    <FormWrapper>
                                        <FormColumn>
                                            {this.renderFormGroup('Subject', {
                                                defaultValue: '',
                                                // disabled: true,
                                                type: 'text',
                                                id: 'sub',
                                                required: false,
                                                value: this.state.sub,
                                                onChange: e => {
                                                    this.setState({ sub: e.target.value });
                                                }
                                            })}
                                        </FormColumn>
                                    </FormWrapper>
                                    <Editor
                                        // editorState={editorState}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                        onEditorStateChange={this.onEditorStateChange}
                                    />
                                    <ModalFooter style={{ position: 'relative', padding: '0px' }}>
                                        <ButtonCommonTheme
                                            btnType="submit"
                                            type='blueModalBtn'
                                            btnStyle="default"
                                            size="xl"
                                            style={{ float: 'right' }}
                                        >
                                            Save
                                        </ButtonCommonTheme>
                                    </ModalFooter>
                                </form>
                            </TabItemsStyle>
                        </Tab>

                    </Tabs>
                </CustomTabs>
            </DataWrapperClass>
        )
    }
}

export default ContactInfoNoteTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ContactInfoNoteTheme.js